module.exports = __webpack_public_path__ + "static/media/cancel.3cd7243a.svg";